import { render, staticRenderFns } from "./ComplaintModal.vue?vue&type=template&id=dd78d1a6&scoped=true"
import script from "./ComplaintModal.vue?vue&type=script&lang=js"
export * from "./ComplaintModal.vue?vue&type=script&lang=js"
import style0 from "./ComplaintModal.vue?vue&type=style&index=0&id=dd78d1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd78d1a6",
  null
  
)

export default component.exports